// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-select-image{width:100%}.vue-select-image .vue-select-image__wrapper{margin:10px 0;width:100%}.vue-select-image .vue-select-image__wrapper .vue-select-image__item{list-style-type:none;width:25%;float:left;border:5px solid #fff}.vue-select-image .vue-select-image__wrapper .vue-select-image__item .vue-select-image__thumbnail{outline:5px solid transparent}.vue-select-image .vue-select-image__wrapper .vue-select-image__item .selected{outline:5px solid #6cc}", ""]);
// Exports
module.exports = exports;
